import type { SiteTheme } from '../../../theme';

import { useAppSelector } from '../../common/hooks/useThunkDispatch';
import { featureFlagsSelectors } from '../../common/selectors/featureFlagsSelectors';

const isId26Theme = (siteTheme: SiteTheme | undefined): boolean => {
    return siteTheme === 'id26-light' || siteTheme === 'id26-dark';
};

export const useIsId26Theme = () => {
    const siteTheme = useAppSelector(featureFlagsSelectors.selectSiteTheme);
    return isId26Theme(siteTheme);
};
